import { io } from "socket.io-client";

const URL: any = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}sultan`
  : undefined;

export const socket = io(URL, { autoConnect: false, withCredentials: true });
